import type { CreateWorkspaceRequest } from './workspaces.contract';

/** Backend `ERROR_COMPANY_NAME_TOO_LONG` — `len([]rune(name)) > 35`. */
export const COMPANY_NAME_MAX_LENGTH = 35;

/**
 * Backend `NormalizeCompanyCode`: a company (registration/organisation) code
 * is at most 32 characters once its spaces are gone.
 */
export const COMPANY_CODE_MAX_LENGTH = 32;

/** A company code as the backend stores it: "923 456 789" is "923456789". */
export function normaliseCompanyCode(code: string): string {
  return code.replace(/\s+/g, '');
}

/** A company email as the backend stores it: trimmed and lower-case. */
export function normaliseCompanyEmail(email: string): string {
  return email.trim().toLowerCase();
}

/** React `NULL_SALARY_TYPE_CODE` / `NULL_OVERTIME_THRESHOLD` when overtime is off. */
const NULL_SALARY_TYPE_CODE = '1000';
const NULL_OVERTIME_THRESHOLD = '999';
const NULL_OVERTIME_MULTIPLIER = '0';

/** React wizard's `Country.NO`. */
const DEFAULT_COUNTRY = 'no';

/** What the add-company dialog asks for. */
export interface NewWorkspace {
  readonly name: string;
  /** The organisation number, as typed. */
  readonly code: string;
}

/** The one place that knows the backend's field names for company create. */
export function toCreatePayload(workspace: NewWorkspace): CreateWorkspaceRequest {
  return {
    name: workspace.name.trim(),
    code: normaliseCompanyCode(workspace.code),
    vat: '',
    post_code: '',
    phone: '',
    street: '',
    house: '',
    city: '',
    country: DEFAULT_COUNTRY,
    is_company_is_staffing: false,
    job_titles_templates: [],
    employment_templates: [],
    overtime_threshold: NULL_OVERTIME_THRESHOLD,
    salary_type_code: NULL_SALARY_TYPE_CODE,
    overtime_multiplier: NULL_OVERTIME_MULTIPLIER,
    account: '',
    account_type: '',
  };
}
